import React, { useState } from 'react';
import { Plus, Minus } from 'lucide-react';
import { faqs } from '../../data/mock';

const FAQ = () => {
  const [open, setOpen] = useState(0);
  return (
    <section id="faq" className="section" style={{ background: '#FFFFFF' }}>
      <div className="container-x">
        <div className="grid lg:grid-cols-12 gap-10 mb-12 md:mb-16">
          <div className="lg:col-span-5">
            <div className="flex items-center gap-3 mb-6">
              <span className="h-2 w-2 rounded-full" style={{ background: '#2EF5FF' }} />
              <span className="text-xs md:text-sm uppercase tracking-[0.25em] font-medium text-[#12367F]/70">
                Frequently Asked Questions
              </span>
            </div>
            <h2
              className="font-display uppercase text-[#12367F] text-balance"
              style={{ fontSize: 'clamp(2.25rem, 5vw, 4.5rem)', lineHeight: 0.92 }}
            >
              You have questions,{' '}
              <span style={{ background: '#2EF5FF' }} className="px-2 rounded-md">we have answers</span>
            </h2>
          </div>
          <div className="lg:col-span-7">
            <div className="divide-y divide-[#12367F]/15 border-y border-[#12367F]/15">
              {faqs.map((f, idx) => {
                const isOpen = open === idx;
                return (
                  <div key={f.q}>
                    <button
                      onClick={() => setOpen(isOpen ? -1 : idx)}
                      className="w-full flex items-center justify-between gap-4 text-left py-6 group"
                    >
                      <span className="font-display uppercase text-[#12367F] group-hover:text-[#12367F]/80 transition-colors" style={{ fontSize: 'clamp(1.1rem, 1.8vw, 1.7rem)' }}>
                        {f.q}
                      </span>
                      <span
                        className={`shrink-0 h-9 w-9 md:h-10 md:w-10 rounded-full grid place-items-center transition-colors ${
                          isOpen ? 'bg-[#12367F] text-white' : 'bg-[#2EF5FF] text-[#12367F]'
                        }`}
                      >
                        {isOpen ? <Minus className="h-4 w-4" /> : <Plus className="h-4 w-4" />}
                      </span>
                    </button>
                    <div
                      className={`grid transition-all duration-300 ${
                        isOpen ? 'grid-rows-[1fr] opacity-100 pb-6' : 'grid-rows-[0fr] opacity-0'
                      }`}
                    >
                      <div className="overflow-hidden">
                        <p className="text-[#12367F]/80 text-base md:text-lg leading-relaxed max-w-2xl">{f.a}</p>
                      </div>
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default FAQ;
